import React, { Component } from 'react';
import {Paper, Grid, Typography, Button, IconButton, Tooltip} from '@material-ui/core';
import * as Gserv from '../services/GatewayService';
// import Settings from '@material-ui/icons/Settings';
import DatasheetView from './DatasheetView';
import DropDown from './DropDown';
import DatePicker from './DatePicker';
import { Delete, DeleteOutlineRounded, NoteAddRounded, Settings, VisibilityRounded } from '@material-ui/icons';
import InputField from './InputField';
import moment from 'moment';

export default class QualificationsSubform extends Component {

    constructor(props) {
        super(props);
        this.reset_state = {
            assessments_view: false,
            empl_num_error: null,
            empl_num_input: '',
            name_error: null,
            name_input: '',
            can_submit: true,
            writing: false,
            deleting: false,
            error: false,
            error_message: '',
            file_warning: '',
            querying: true,
            matrix_array: [],
            show_dialogue: false,
            form_view: false,
            add_file: false,
            qual_id_for_file_add: '',
            form_data: {},
            current_record: {},
            primary_button_enabled: false,
            primary_button_text: 'Add Qualification',
            nqf_level_disabled: false,
            discipline_disabled: false,
            expires_disabled: false,
            discipline_description: '',
            selectedFile: null,
        }
        this.state = {  //Note: qual_types & qual_disciplines not reset
            assessments_view: false,
            empl_num_error: null,
            empl_num_input: '',
            name_error: null,
            name_input: '',
            can_submit: true,
            writing: false,
            deleting: false,
            qual_types: [],
            qual_disciplines: [],
            error: false,
            error_message: '',
            file_warning: '',
            querying: true,
            matrix_array: [],
            show_dialogue: false,
            form_view: false,
            add_file: false,
            qual_id_for_file_add: '',
            form_data: {},
            current_record: {},
            primary_button_enabled: false,
            primary_button_text: 'Add Qualification',
            nqf_level_disabled: false,
            discipline_disabled: false,
            expires_disabled: false,
            discipline_description: '',
            selectedFile: null,
        };

        this.nqf_down_ref = React.createRef();
        this.discipline_down_ref = React.createRef();
        this.expires_ref = React.createRef();

        this.nqf_array = [
            {id: 1, level: 'Level 1'},
            {id: 2, level: 'Level 2'},
            {id: 3, level: 'Level 3'},
            {id: 4, level: 'Level 4'},
            {id: 5, level: 'Level 5'},
            {id: 6, level: 'Level 6'},
            {id: 7, level: 'Level 7'},
            {id: 8, level: 'Level 8'},
            {id: 9, level: 'Level 9'},
            {id: 10, level: 'Level 10'},
            {id: 0, level: 'Not Applicable'}
        ]

        this.datasheetFieldSpecs = [
            // { field: 'id', headerName: 'Empl. #', width: 90, sortable:false},
            { field: 'qualification_type', headerName: 'Qual. Type', width: 250, sortable:false},
            { field: 'qual_discipline', headerName: 'Academic Discipline', width: 210, sortable:false},
            { field: 'description', headerName: 'Description', width: 150, sortable: false},
            { field: 'nqf_level', headerName: 'NQF level', width: 75, align:'center', sortable:false},
            { field: 'year_obtained', headerName: 'Year Obtained', width: 100, align:'center'},
            { field: 'expires', headerName: 'Expires?', width: 120,
            renderCell: (parms) => (
                (parms.row.expires)&&
                <span style={{color: -moment().diff(parms.row.expires,'days') < 1 ? '#FF0000' : -moment().diff(parms.row.expires,'days') < 30 ? '#FF9900' : ''}}>{parms.row.expires}</span>
            )},
            { field: 'file_attachment', headerName: 'Document Attached', width: 70, align:'center', sortable:false,
            renderCell: (parms) => (
                (parms.row.file_attachment==="YES")&&
                <IconButton
                    onClick={()=>this.viewDoc(parms)} 
                >
                    <Tooltip title="View Document Attachment">
                        <VisibilityRounded/>
                    </Tooltip>
                </IconButton>
            )},
            { field: 'add_file_attachment', headerName: 'Add or Remove Document', width: 70, align:'center', sortable:false,
            renderCell: (parms) => {
                if (parms.row.file_attachment==="YES"){
                    return (<IconButton
                        onClick={()=>this.removeDoc(parms)} 
                        >
                            <Tooltip title="Remove Document Attachment">
                                <DeleteOutlineRounded/>
                            </Tooltip>
                        </IconButton>);
                } else {
                    return (<IconButton
                    onClick={()=>this.setState({form_view:true,add_file:true, qual_id_for_file_add: parms.row.id})} 
                    >
                        <Tooltip title="Add Document Attachment">
                            <NoteAddRounded/>
                        </Tooltip>
                    </IconButton>);
                }
            }
            },
            { field: 'comment', headerName: 'Comment', width: 300, sortable:false}
        
        ]

        this.input_fieldSpecs = [

            {field: "qualification_type_id", headerName: "Qualification Type", f_inputType:'dropdown', f_show:true, f_required:true},

            {field: "description", headerName: "Description", f_inputType:'text', f_show:true, f_required:true,  f_maxLength: 500},

            {field: "nqf_level", headerName: "NQF Level", f_inputType:'dropdown', f_show:true, f_required:true},

            {field: "year_obtained", headerName: "Year Obtained", f_inputType:'text', f_show:true, f_required:true,  f_maxLength: 4, f_minLength: 4, f_pattern:"^[0-9]+$"},

            {field: "expires", headerName: "Expires?", f_inputType:'datepicker', f_show:true, f_required:false},
            
            {field: "qualification_discipline_id", headerName: "Discipline", f_inputType:'dropdown', f_show:true, f_required:true},

            {field: "comment", headerName: "Comment", f_inputType:'text', f_show:true, f_required:false,  f_maxLength: 500},

        ]
    }

    componentDidMount = () => {

        //async get qual_types... - once off
        if (this.state.qual_types.length===0){  
            Gserv.sendCommand('query_qualification_types',this.props.gwt)
            .then(qual_types => {
                // console.log('assessment_types :>> ', ass_types);
                if (qual_types.error){
                    console.log('error on return from Gserv (query_qualification_types) :>> ', qual_types);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else if (qual_types.Result!=="Success"&&qual_types.statusCode!==204){
                    console.log('error on return from Gserv (query_qualification_types) :>> ', qual_types);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else {

                    this.setState({qual_types: qual_types.Records});
                }
            }); 
        }
 
        //async get qual_disciplines... - once off
        if (this.state.qual_disciplines.length===0){  
            Gserv.sendCommand('query_qualification_disciplines',this.props.gwt)
            .then(qual_disciplines => {
                // console.log('qual_disciplines :>> ', qual_disciplines);
                if (qual_disciplines.error){
                    console.log('error on return from Gserv (query_qualification_disciplines) :>> ', qual_disciplines);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else if (qual_disciplines.Result!=="Success"&&qual_disciplines.statusCode!==204){
                    console.log('error on return from Gserv (query_qualification_disciplines) :>> ', qual_disciplines);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else {
                    this.setState({qual_disciplines: qual_disciplines.Records});
                }
            }); 
        }

        Gserv.sendCommand('query_employee_qualifications',this.props.gwt,{
            employee_number: this.props.employee.employee_number
        })
        .then(reply=>{
            // console.log('query_employee_qualifications reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (query_employee_qualifications) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (query_employee_qualifications) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {

                this.setState({querying:false, matrix_array:reply.Records? reply.Records : []});
            }
        });
    };

    editAssessments = (parms) => {
        // console.log('edit assessments with parms :>> ', parms);
        this.setState({current_record:parms.row});
    }

    processForm = (e) => {
        e.preventDefault();
        // console.log('this.state.form_data :>> ', this.state.form_data);

        this.setState({writing:true, primary_button_enabled:false});
        //set state updating here...
        
        if (this.state.qual_id_for_file_add&&this.state.add_file&&this.state.selectedFile){
            //this is a file upload only

            // console.log('Called add file');

            let payload = {
                employee_number : this.props.employee.employee_number,
                qualification : this.state.qual_id_for_file_add
            }

            const formData = new FormData();
            formData.append("payload",JSON.stringify(payload));
    
            formData.append("qFile",this.state.selectedFile,this.state.selectedFile.name);
            
            Gserv.sendForm('add_file_to_qualification',this.props.gwt,formData)
            .then(reply=>{
                if (reply.error){
                    console.log('error on return from Gserv (add_file_to_qualification) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",writing:false});
                } else if (reply.Result!=="Success"){
                    console.log('error on return from Gserv (add_file_to_qualification) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",writing:false});
                } else {
                    this.resetMe();           
                }
            });
        } else if (this.state.current_record.id){
               //this is an update

               Gserv.sendCommand('update_qualification',this.props.gwt,{
                form_data : this.state.form_data,
                id : this.state.current_record.id
            })
            .then(reply => {
                // console.log('update reply :>> ', reply);
                if (reply.error){
                    console.log('error on return from Gserv (update_qualification) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",writing:false});
                } else if (reply.Result!=="Success") {
                    console.log('error on return from Gserv (update_qualification) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",writing:false});
                } else {
                    this.resetMe();
                    // this.setState(this.reset_state);
                    // this.componentDidMount();
                }
            });           

        } else if (!this.state.add_file) {
            //this is a create
            // console.log('Called create record...');

            let payload = this.state.form_data
            payload.employee_number = this.props.employee.employee_number;

            const formData = new FormData();
            formData.append("payload",JSON.stringify(payload));
    
            if (this.state.selectedFile){formData.append("qFile",this.state.selectedFile,this.state.selectedFile.name)}
            
            Gserv.sendForm('create_qualification',this.props.gwt,formData)
            .then(reply=>{
                if (reply.error){
                    console.log('error on return from Gserv (create_qualification) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",writing:false});
                } else if (reply.Result!=="Success"){
                    console.log('error on return from Gserv (create_qualification) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",writing:false});
                } else {
                    this.resetMe();           
                }
            });

        }
    }

    handleFieldUpdate = (fieldObj) => {
        // console.log('called field update...');
        // console.log('fieldObj :>> ', fieldObj);
        // console.log('child field update:',fieldObj);
        // console.log(this.state.current_record);
        // eslint-disable-next-line eqeqeq
        if (fieldObj.value==''){fieldObj.value=null}
        let myFormData = this.state.form_data;
        myFormData[fieldObj.field] = fieldObj.value;
        this.setState({form_data:myFormData});
        // console.log('current_record value : ',this.state.current_record[fieldObj.field]);
        // console.log('New value : ', fieldObj.value);
        // eslint-disable-next-line eqeqeq
        if(this.state.current_record[fieldObj.field]!=fieldObj.value){
            const truthyCurrentRec = this.state.current_record[fieldObj.field]? true : false;
            const truthyFieldObj = fieldObj.value ? true : false;
            //exclude nulls vs '' vs false etc.
            if (truthyCurrentRec||truthyFieldObj){
                // console.log('found update...');
                this.setState({primary_button_enabled:true});
            }
        } 
    }
    
    handleQualTypeUpdate = (fieldObj) => {
        // console.log('called field update...');
        // console.log('fieldObj.value :>> ', fieldObj.value);
        // console.log('child field update:',fieldObj);
        // console.log(this.state.current_record);
        // eslint-disable-next-line eqeqeq
        if (fieldObj.value==''){fieldObj.value=null}
        let myFormData = this.state.form_data;
        myFormData[fieldObj.field] = fieldObj.value;

        const q_type = this.getQualTypeMetrics(fieldObj.value);
        // console.log('q_type :>> ', q_type);

        //Deal with associated nqf_level
        if (!q_type.associated_nqf&&(q_type.associated_nqf!==0)){
            // There's NOT an NQF level associated with qualification type
            // console.log('No NQF');
            myFormData['nqf_level'] = null;
            if (this.nqf_down_ref.current){
                this.nqf_down_ref.current.resetMe();
            }
            this.setState({nqf_level_disabled:false});
        } else {
            // There IS an NQF level associated with qualification type
            // console.log('Found NQF...');
            myFormData['nqf_level'] = q_type.associated_nqf;
            if (this.nqf_down_ref.current){
                this.nqf_down_ref.current.state.fieldValue = q_type.associated_nqf;
            }
            this.setState({nqf_level_disabled:true});
        }

        //Disable expiry field, unless qualification is a type that can expire...
        if (q_type.can_expire){
            this.setState({expires_disabled:false})
        } else {
            myFormData['expires'] = null;
            if (this.expires_ref.current){
                this.expires_ref.current.state.fieldValue = null; 
            }
            this.setState({expires_disabled:true})
        }


        //Force selection of discipline, where Matric or Branch Appointment is selected...
        if (q_type.force_qual_discipline_id){
            // console.log('Matric selected');
            myFormData['qualification_discipline_id'] = q_type.force_qual_discipline_id;
            if (this.discipline_down_ref.current){
                this.discipline_down_ref.current.state.fieldValue = q_type.force_qual_discipline_id;
            }
            const discipline_description = this.getQualDisciplineDescription(q_type.force_qual_discipline_id);
            this.setState({discipline_disabled:true, discipline_description: discipline_description});
        } else {
            // console.log('Not Matric or Branch Appointment selected...');
            if (this.discipline_down_ref.current){
                this.discipline_down_ref.current.resetMe();
            }
            this.setState({discipline_disabled:false, discipline_description: ''});
        }

        this.setState({form_data:myFormData});
        // console.log('current_record value : ',this.state.current_record[fieldObj.field]);
        // console.log('New value : ', fieldObj.value);
        // eslint-disable-next-line eqeqeq
        if(this.state.current_record[fieldObj.field]!=fieldObj.value){
            const truthyCurrentRec = this.state.current_record[fieldObj.field]? true : false;
            const truthyFieldObj = fieldObj.value ? true : false;
            //exclude nulls vs '' vs false etc.
            if (truthyCurrentRec||truthyFieldObj){
                // console.log('found update...');
                this.setState({primary_button_enabled:true});
            }
        } 
    }

    handleQualDisciplineUpdate = (fieldObj) => {
        // eslint-disable-next-line eqeqeq
        if (fieldObj.value==''){fieldObj.value=null}
        let myFormData = this.state.form_data;
        myFormData[fieldObj.field] = fieldObj.value;

        const discipline_description = fieldObj.value? this.getQualDisciplineDescription(fieldObj.value) : '';
        
        this.setState({form_data:myFormData, discipline_description: discipline_description});

        if(this.state.current_record[fieldObj.field]!==fieldObj.value){
            const truthyCurrentRec = this.state.current_record[fieldObj.field]? true : false;
            const truthyFieldObj = fieldObj.value ? true : false;
            //exclude nulls vs '' vs false etc.
            if (truthyCurrentRec||truthyFieldObj){
                // console.log('found update...');
                this.setState({primary_button_enabled:true});
            }
        } 

    }

    handleUpdate = (record) => {
        // console.log('record for update :>> ', record);
        // this.setState({show_dialogue:true});
        //Hide just while testing modal...
        this.setState({current_record:record.row,form_view:true,primary_button_enabled:false,primary_button_text:'Update Qualification'});
    }

    handleDelete = (record) => {
        // console.log('record for delete :>> ', record);
        // this.setState({show_dialogue:true});

        this.setState({deleting:true,querying:true});
        Gserv.sendCommand('delete_qualification',this.props.gwt,{
            qualification_id: record.id
        })
        .then(reply => {
            // console.log('delete reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (delete_qualification) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"){
                console.log('error on return from Gserv (delete_qualification) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                this.resetMe();
            }
        });
    }
    
    resetMe = () => {
        this.setState(this.reset_state);
        this.componentDidMount();
    }

    getQualTypeMetrics = (qual_type_id) => {
        var flag = false;
        var i = 0;
        while (flag===false && i<this.state.qual_types.length) {
            if (this.state.qual_types[i].id===Number(qual_type_id)){
                flag = true;
                // console.log('this.state.qual_types[i].id :>> ', this.state.qual_types[i].id);
            } else {
                i++;
            }
        }
        if (flag){
            return {
                associated_nqf : this.state.qual_types[i].nqf_level,
                can_expire : this.state.qual_types[i].can_expire,
                force_qual_discipline_id : this.state.qual_types[i].force_qual_discipline_id
            };
        } else {
            return {}
        }
    }

    getQualDisciplineDescription = (qual_discipline_id) => {
        var flag = false;
        var i = 0;
        while (flag===false && i<this.state.qual_disciplines.length) {
            if (this.state.qual_disciplines[i].id===Number(qual_discipline_id)){
                flag = true;
                // console.log('this.state.qual_types[i].id :>> ', this.state.qual_types[i].id);
            } else {
                i++;
            }
        }
        if (flag){
            return this.state.qual_disciplines[i].description;
        } else {
            return '';
        }
    }

    onFileChange = event => {
        // console.log('onFileChange called');
        // Update the state
        if (event.target.files[0]){
            // console.log('event.target.files[0] :>> ', event.target.files[0]);
            if (event.target.files[0].size>2048000){
                this.setState({selectedFile:null,file_warning:'The file selected is larger that 2mb. Please select a smaller file for upload.'});  
            } else if (event.target.files[0].name.slice(-4)!=='.pdf'&&event.target.files[0].name.slice(-4)!=='.PDF'){
                this.setState({selectedFile:null,file_warning:'The selected file does not appear to be a Portable Document Format (PDF) file. Please select .pdf file for upload.'});  
            } else {
                this.setState({selectedFile: event.target.files[0],partially_complete:true, file_warning:''});
                if (this.state.add_file && (this.state.qual_id_for_file_add !== '')){this.setState({primary_button_enabled:true})}
            }
        } else {
            this.setState({selectedFile:null, file_warning:''});
        }
    };
    
    clearFile = () => {
        document.getElementById('file-upload-obj').value = null;
        this.setState({selectedFile: null});
        if (this.state.add_file){
            this.setState({primary_button_enabled:false});
        }
    };

    viewDoc = (parms) => {
        // console.log('parms.row :>> ', parms.row);
        this.setState({querying:true});
        Gserv.sendCommand('query_qualification_attachment',this.props.gwt,{
            file_key: parms.row.file_key
        })
        .then(file_url => {
            // console.log('file_url obj returned :>> ', file_url);
            if (file_url.error){
                console.log('error on return from Gserv (query_qualification_attachment) :>> ', file_url);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (file_url.Result!=="Success"&&file_url.statusCode!==204){
                console.log('error on return from Gserv (query_qualification_attachment) :>> ', file_url);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                window.open(file_url.Url, '_blank', 'noopener,noreferrer');
                // const newWindow = window.open(file_url.Url, '_blank', 'noopener,noreferrer');
                // if (newWindow) newWindow.opener = null
            }
            this.setState({querying:false})
        }); 
    }

    removeDoc = (parms) => {
        // console.log('parms :>> ', parms);

        if (window.confirm("This function will remove the document attachment from this qualification: " + parms.row.qualification_type + " : " + parms.row.description + " - this cannot be undone. Are you sure you wish to proceed?")){
            // console.log('Proceed with reset...');
            this.setState({writing:true, primary_button_enabled:false});

            Gserv.sendCommand('remove_file_from_qualification',this.props.gwt,{
                id : parms.row.id
            })
            .then(reply => {
                // console.log('update reply :>> ', reply);
                if (reply.error){
                    console.log('error on return from Gserv (remove_file_from_qualification) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",writing:false});
                } else if (reply.Result!=="Success") {
                    console.log('error on return from Gserv (remove_file_from_qualification) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",writing:false});
                } else {
                    this.resetMe();
                }
            });           
        } 
    }

    render() {
        return (
            <Grid
                container
                direction='column'
                justifyContent='center'
                alignContent='center'
                style={{width:1250}}
            >
                
                <Paper
                    elevation={3}
                >
                    <Typography
                        style={{padding:20}}
                    >
                       <b>{this.props.employee.name}</b> (Empl.# {this.props.employee.employee_number})<br/>
                       <b>{this.props.employee.job_title}</b> [{this.props.employee.store_code}] <br/>
                       Reporting to Manager: {this.props.employee.reports_to_rom}
                    </Typography> 
    
                    <hr/>

                    {!this.state.form_view&&
                    <Grid
                        container
                        direction='row'
                        justifyContent='center'
                        alignContent='center'
                        style={{padding:15}}
                    >
                        <Button
                            variant='contained'
                            color='primary'
                            // type='submit'
                            onClick={()=>this.setState({form_view:true,primary_button_text:'Add Qualification',current_record:{}})}
                            disabled={this.state.form_view}
                        >
                            Add Qualification
                        </Button>
                        <Button 
                            // type='button'
                            variant='outlined'
                            disabled={this.state.writing}
                            onClick={()=>this.props.setParentState({form_view:false})}
                            style={{marginLeft:'15px'}}
                        >
                            Back
                        </Button>
                    </Grid>}
                    
                    {!this.state.form_view&&
                    <Typography
                        color='primary'
                        style={{paddingTop:15}}
                    >
                        {this.props.employee.name}'s Qualifications
                    </Typography>}

                </Paper>

                {/* Datagrid goes here */}
                {!this.state.form_view&&!this.writing&&
                <DatasheetView 
                    dataset={this.state.matrix_array}
                    fieldspecs={this.datasheetFieldSpecs}
                    delete={true}
                    edit={true}
                    handleDelete={this.handleDelete}
                    handleEdit={this.handleUpdate}
                    loading={this.state.querying}
                    deleteHeaderName={'Delete Qualification'}
                    pagesize={8}
                />}

                {this.state.form_view&&!this.state.writing&&
                <Paper
                    elevation={3}
                    style={{width:'100%'}}
                >
                    <form onSubmit={this.processForm}>
                        <br/>

                        {!this.state.add_file&&
                        <Grid 
                            container 
                            direction='column'
                            alignItems='baseline'
                            justifyContent='flex-start'
                            spacing={1}
                            style={{marginLeft:'10%' }}
                        >


                            <DropDown fieldMap={this.input_fieldSpecs[0]} setField={this.handleQualTypeUpdate} editRecord={this.state.current_record} listArray={this.state.qual_types} disabled={this.state.writing}/>
                            
                            <div style={{width:"80%"}}>
                                <InputField fieldMap={this.input_fieldSpecs[1]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} disabled={this.state.writing}/>
                            </div>

                            <DropDown fieldMap={this.input_fieldSpecs[2]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} listArray={this.nqf_array} disabled={this.state.writing||this.state.nqf_level_disabled} ref={this.nqf_down_ref}/>

                            <div style={{width:"20%"}}>
                                <InputField fieldMap={this.input_fieldSpecs[3]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} disabled={this.state.writing}/>
                            </div>

                            <div style={{width:'20%'}}>
                                <DatePicker fieldMap={this.input_fieldSpecs[4]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} disabled={this.state.writing||this.state.expires_disabled} ref={this.expires_ref}/>
                            </div>

                            <DropDown fieldMap={this.input_fieldSpecs[5]} setField={this.handleQualDisciplineUpdate} editRecord={this.state.current_record} listArray={this.state.qual_disciplines} disabled={this.state.writing||this.state.discipline_disabled} ref={this.discipline_down_ref}/>

                            <div style={{width:"80%"}}>
                                <Typography style={{textAlign:'left'}}><i>{this.state.discipline_description}</i></Typography>
                            </div>

                            <div style={{width:"80%"}}>
                                <InputField fieldMap={this.input_fieldSpecs[6]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} disabled={this.state.writing}/>
                            </div>

                            <br/>


                            {!this.state.current_record.id&&
                            <Grid item>
                            <Grid 
                                container
                                direction='column'
                                alignContent='center'
                                justifyContent='center'
                                style={{height:'100%'}}
                            >
                                <input
                                    accept="application/pdf"
                                    style={{ display: 'none' }}
                                    id="file-upload-obj"
                                    multiple={false}
                                    type="file"
                                    onChange={this.onFileChange}
                                    disabled={this.state.selectedFile? true : false}
                                />
                                <label htmlFor="file-upload-obj">
                                    <Button 
                                        variant="contained"
                                        color='primary'
                                        component="span"
                                        disabled={this.state.selectedFile? true : false}
                                        style={{marginBottom:15}}
                                    >
                                        Upload Qualification Document
                                    </Button>
                                </label>

                                {this.state.selectedFile&&
                                <Typography>
                                    {this.state.selectedFile.name}
                                    <IconButton
                                        onClick={this.clearFile}
                                    >
                                        <Delete/>
                                    </IconButton>
                                </Typography>}

                            </Grid>
                            </Grid>}

                            {this.state.file_warning&&
                            <Typography color='secondary' style={{maxWidth:600, textAlign:'left'}}><i>{this.state.file_warning} <b>This file will not be uploaded</b>.</i></Typography>}

                        </Grid>}

                        {this.state.add_file&&        
                        <Grid 
                            container 
                            direction='column'
                            alignItems='baseline'
                            justifyContent='flex-start'
                            spacing={1}
                            style={{marginLeft:'10%' }}
                        >

                            <Grid item>
                            <Grid 
                                container
                                direction='column'
                                alignContent='center'
                                justifyContent='center'
                                style={{height:'100%'}}
                            >
                                <input
                                    accept="application/pdf"
                                    style={{ display: 'none' }}
                                    id="file-upload-obj"
                                    multiple={false}
                                    type="file"
                                    onChange={this.onFileChange}
                                    disabled={this.state.selectedFile? true : false}
                                />
                                <label htmlFor="file-upload-obj">
                                    <Button 
                                        variant="contained"
                                        color='primary'
                                        component="span"
                                        disabled={this.state.selectedFile? true : false}
                                        style={{marginBottom:15}}
                                    >
                                        Upload Qualification Document
                                    </Button>
                                </label>

                                {this.state.selectedFile&&
                                <Typography>
                                    {this.state.selectedFile.name}
                                    <IconButton
                                        onClick={this.clearFile}
                                    >
                                        <Delete/>
                                    </IconButton>
                                </Typography>}

                            </Grid>
                            </Grid>

                            {this.state.file_warning&&
                            <Typography color='secondary' style={{maxWidth:600, textAlign:'left'}}><i>{this.state.file_warning} <b>This file will not be uploaded</b>.</i></Typography>}

                        </Grid>}


                        <Button 
                            color='primary'
                            variant='outlined'
                            disabled={!this.state.primary_button_enabled}
                            type='submit'
                            style={{marginTop:'20px', marginBottom: '20px'}}
                        >
                            {this.state.primary_button_text}
                        </Button>
                        <Button 
                            type='button'
                            variant='outlined'
                            disabled={this.state.writing}
                            onClick={()=>this.setState({form_view:false, add_file:false,qual_id_for_file_add: false})}
                            style={{marginTop:'20px', marginBottom: '20px'}}
                        >
                            Cancel
                        </Button>
                    </form>
                </Paper>}

                {this.state.writing&&            
                <div className='pageContainer' style={{minHeight:'70vh'}}>
                    <div>
                        <Settings className='icn-spinner' /> Saving Qualification...
                    </div>
                </div>}

                <Grid item>
                    <Typography color='secondary' style={{Width:1250,maxWidth:1250, textAlign:'center'}}>{this.state.error_message}</Typography>
                    {this.state.error&&<Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>}
                </Grid>


            </Grid>
        );
    }
    
}